import { render, staticRenderFns } from "./PreviewFullScreen.vue?vue&type=template&id=45abb56c&"
import script from "./PreviewFullScreen.vue?vue&type=script&lang=js&"
export * from "./PreviewFullScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports